import { render } from "./Job.vue?vue&type=template&id=920598b4&scoped=true&ts=true"
import script from "./Job.vue?vue&type=script&lang=ts"
export * from "./Job.vue?vue&type=script&lang=ts"

import "./Job.vue?vue&type=style&index=0&id=920598b4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-920598b4"]])

export default __exports__